import { API_TAGS } from "../../helpers/constants";
import { api } from "../api";

export interface ICreatePromocodeRequest {
  userId: number;
  cases: number;
  price: number;
  currency?: string;
}

export interface ICreatePromocodeResponse {
  id: number;
}

export interface IAddLeftCasesRequest {
  id: number;
  amount: number;
}

export interface IAdminUserSummary {
  id: number | string;
  email: string;
  firstName: string;
  lastName: string;
}

export interface IUserOption {
  id: number | string;
  label: string;
}

export const adminApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchUsers: builder.query<
      IUserOption[],
      { query: string; limit?: number }
    >({
      query: ({ query, limit = 10 }) => ({
        url: `admin/users`,
        method: "GET",
        params: { search: query, limit },
      }),
      // Support response shape: { total, items: IAdminUserSummary[] }
      transformResponse: (
        response:
          | { total?: number; items?: IAdminUserSummary[] }
          | IAdminUserSummary[]
      ) => {
        const list = Array.isArray(response)
          ? response
          : Array.isArray(response?.items)
          ? response.items || []
          : [];
        return list.map((u) => {
          const first = (u.firstName || "").trim();
          const last = (u.lastName || "").trim();
          const name = `${first} ${last}`.trim();
          const label = name.length ? `${name} (${u.email})` : u.email;
          return { id: u.id, label };
        });
      },
      providesTags: [],
    }),
    createPromocode: builder.mutation<
      ICreatePromocodeResponse,
      ICreatePromocodeRequest
    >({
      query: ({ userId, cases, price, currency = "KZT" }) => ({
        url: `admin/${userId}/promocode`,
        method: "POST",
        params: {
          cases,
          price,
          currency,
        },
      }),
      invalidatesTags: [API_TAGS.USER],
    }),
    addLeftCases: builder.mutation<unknown, IAddLeftCasesRequest>({
      query: ({ id, amount }) => ({
        url: `admin/${id}/left-cases`,
        method: "PUT",
        body: { amount },
      }),
      invalidatesTags: [API_TAGS.USER],
    }),
  }),
});

export const {
  useCreatePromocodeMutation,
  useLazySearchUsersQuery,
  useAddLeftCasesMutation,
} = adminApi;
